import React from 'react';
import { Link } from 'react-router-dom';

export default function AccountDetailsCard() {
	return (
		<div className="AccountDetailsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">
						Account Profile
					</h2>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<span className="float-right hover:underline">
							<Link
								to="edit"
								state={{
									isEditing: true
								}}
							>
								Edit
							</Link>
						</span>
						<div className="grid md:grid-cols-12">
							<div className="md:col-span-6">
								<div className="font-semibold">Account Name</div>
								<span className="my-1 mr-3">JS Maui Properties</span>
								<div className="font-semibold mt-4">Mailing Address</div>
								<span className="mr-2 block">5753 W Alder Ave.</span>
								<span className="mr-2 block" />
								<span className="mr-1">Littleton,</span>
								<span className="mr-1">CO</span>
								<span className="mr-1">80128</span>
								<div className="font-semibold mt-4">Phone Number</div>
								<span className="my-1 mr-3">303-847-7964</span>
							</div>
							<div className="md:col-span-6 mt-4 md:mt-0">
								<div className="font-semibold">Calculation Type</div>
								<span className="mr-2 block">Top-Down</span>
								<div className="font-semibold mt-4">User</div>
								<span className="mr-2 block">
									<Link to="/user/1" className="hover:underline">
										js23@gmail.com
									</Link>
								</span>
								<div className="font-semibold mt-4">Properties</div>
								<span className="mr-2 block">
									<Link to="/properties/1" className="hover:underline">
										Surfer's Hideaway
									</Link>,{' '}
									<Link to="/properties/1" className="hover:underline">
										Life's a Beach
									</Link>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
